<template>
    <smooth-scrollbar>
        <div style="height:65vh">
            <group v-for="group in orthos" :group="group" :key="group.groupID"></group>
        </div>
    </smooth-scrollbar>
</template>
<script>
import { mapGetters } from "vuex";
import Group from './group.component'
export default {
     components:{
         Group
     },
     computed:{
         ...mapGetters(['orthos'])
     }   
}
</script>
